import {connect} from 'react-redux';
import {GelDragDropQuestion as Component} from '@learningblocks/storybook-components';
import {
  onDropDownUpdate,
  onDropDownSelect,
  onDropDownCloseFeedback,
  onDropDownSubmit,
  onDropDownReset
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {}

}

function mapDispatchToProps(dispatch) {
  return {
    onGelUpdate: (data) => {
      dispatch(onDropDownUpdate(data))
    },
    onDropDownUpdate: (data) => {
      dispatch(onDropDownUpdate(data))
    },
    onGelSelect: (data) => {
      dispatch(onDropDownSelect(data))
    },
    closeFeedback: (data) => {
      dispatch(onDropDownCloseFeedback(data))
    },
    onSubmit: (data) => {
      dispatch(onDropDownSubmit(data))
    },
    onReset: (data) => {
      dispatch(onDropDownReset(data))
    }
  };
}

export const GelDropDownQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
